<!-- =========================================================================================
  File Name: TheNavbar.vue
  Description: Navbar component
  Component Name: TheNavbar
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
	<div class="relative">
		<div class="vx-navbar-wrapper" :class="classObj">
			<vs-navbar
				class="vx-navbar navbar-custom navbar-skelton"
				:color="navbarColorLocal"
				:class="textColor"
			>
				<vx-tooltip
					text="Dashboard"
					position="bottom"
					delay=".3s"
					class="ml-2 mr-6"
				>
					<router-link
						:to="{
							name: 'dashboard',
							params: {
								kate: kate,
							},
						}"
					>
						<feather-icon
							:svgClasses="['h-6 w-6 stroke-current', textColor]"
							class="cursor-pointer"
							style="color: #626262"
							icon="HomeIcon"
						/>
					</router-link>
				</vx-tooltip>
				<vx-tooltip
					text="Action Task List"
					position="bottom"
					delay=".3s"
					class="mr-6"
				>
					<router-link
						:to="{
							name: 'task_list',
							params: {},
						}"
						:style="{color: pendingTasksBadge === '' ? '#00bb6a' : '#e44a7f'}"
					>
						<feather-icon
							:svgClasses="['h-6 w-6 stroke-current', textColor]"
							class="cursor-pointer"
							icon="CheckCircleIcon"
							@click="$router.push('').catch(() => {})"
							:badge="pendingTasksBadge"
						/>
					</router-link>
				</vx-tooltip>
				<!-- re use the following component? -->
				<!-- <notification-drop-down /> -->

				<vx-tooltip text="Customers" position="bottom" delay=".3s" class="mr-6">
					<feather-icon
						:svgClasses="['h-6 w-6 stroke-current', textColor]"
						class="cursor-pointer"
						icon="UsersIcon"
						@click="activePrompt = true"
					/>
				</vx-tooltip>
				<vx-tooltip
					text="Cruise Search"
					position="bottom"
					delay=".3s"
					class="mr-6"
				>
					<feather-icon
						:svgClasses="['h-6 w-6 stroke-current', textColor]"
						class="cursor-pointer"
						icon="SearchIcon"
						@click="$router.push('search').catch(() => {})"
					/>
				</vx-tooltip>

				<!-- SM - OPEN SIDEBAR BUTTON
        <feather-icon class="sm:inline-flex xl:hidden cursor-pointer p-2" icon="MenuIcon" @click.stop="showSidebar" />-->

				<vs-dropdown class="mx-4">
					<a class="a-icon" href="#" v-if="!kate">
						{{
							customer_name
								? customer_name + " | " + customer_trip
								: "Select Customer & Trip"
						}}
						<vs-icon class="" icon="expand_more"></vs-icon>
					</a>
					<a class="a-icon" href="#" v-else>
						Kate | Caribbean Trip
						<vs-icon class="" icon="expand_more"></vs-icon>
					</a>
					<vs-dropdown-menu>
						<vs-dropdown-item> Select Trip </vs-dropdown-item>
						<vs-dropdown-item> Select Customer </vs-dropdown-item>
						<vs-dropdown-item @click="customer_name = ''">
							No Customer
						</vs-dropdown-item>
						<vs-dropdown-item @click="activePrompt = true">
							New Customer
						</vs-dropdown-item>
					</vs-dropdown-menu>
				</vs-dropdown>

				<vs-prompt
					@accept="acceptAlert"
					:active.sync="activePrompt"
					title="New Customer"
				>
					<div class="con-exemple-prompt">
						Customer Name
						<vs-input placeholder="Liz Goldstone" v-model="customer_name" />

						E-Mail
						<vs-input placeholder="" />

						Trip Plan
						<vs-input placeholder="" v-model="customer_trip" />
					</div>
				</vs-prompt>

				<vs-spacer />

				<vx-tooltip
					text="Customer View"
					position="bottom"
					delay=".3s"
					class="mr-6"
				>
					<feather-icon
						:svgClasses="['h-6 w-6 stroke-current', textColor]"
						class="cursor-pointer"
						icon="MonitorIcon"
						@click="$router.push().catch(() => {})"
					/>
				</vx-tooltip>
				<vx-tooltip
					text="Full-screen View (Toggle Kate)"
					position="bottom"
					delay=".3s"
					class="mr-6"
				>
					<feather-icon
						:svgClasses="['h-6 w-6 stroke-current', textColor]"
						class="cursor-pointer"
						icon="Maximize2Icon"
						@click="$bus.$emit('toggle-kate')"
					/>
				</vx-tooltip>

				<profile-drop-down />
			</vs-navbar>
		</div>
	</div>
</template>


<script>
import Bookmarks from "./components/Bookmarks.vue";
import SearchBar from "./components/SearchBar.vue";
import NotificationDropDown from "./components/NotificationDropDown.vue";
import ProfileDropDown from "./components/ProfileDropDown.vue";

export default {
	data() {
		return {
			activePrompt: false,
			activePrompt2: false,
			customer_name: "",
			customer_trip: "",
			kate: false,
      pendingTasksCount: 6,
		};
	},
	name: "the-navbar-vertical",
	props: {
		navbarColor: {
			type: String,
			default: "#fff",
		},
	},
	components: {
		Bookmarks,
		SearchBar,
		NotificationDropDown,
		ProfileDropDown,
	},
	computed: {
		navbarColorLocal() {
			return this.$store.state.theme === "dark" && this.navbarColor === "#fff"
				? "#10163a"
				: this.navbarColor;
		},
		verticalNavMenuWidth() {
			return this.$store.state.verticalNavMenuWidth;
		},
		textColor() {
			return {
				"text-white":
					(this.navbarColor !== "#10163a" &&
						this.$store.state.theme === "dark") ||
					(this.navbarColor !== "#fff" && this.$store.state.theme !== "dark"),
			};
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		validName() {
			return (
				this.valMultipe.value1.length > 0 && this.valMultipe.value2.length > 0
			);
		},
    pendingTasksBadge() {
      return this.pendingTasksCount>0 ? this.pendingTasksCount : "";
    },
		// NAVBAR STYLE
		classObj() {
			if (this.verticalNavMenuWidth === "default") return "navbar-default";
			else if (this.verticalNavMenuWidth === "reduced") return "navbar-reduced";
			else if (this.verticalNavMenuWidth) return "navbar-full";
		},
	},
	methods: {
		showSidebar() {
			this.$store.commit("TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE", true);
		},
		acceptAlert() {
			this.$vs.notify({
				color: "success",
				title: "Accept Selected",
				text: `${this.customer_name} is now the active customer`,
			});
		},
	},
	mounted() {
		let that = this;
		that.$bus.$on("toggle-kate", function (newVal) {
			if (newVal === null) {
				newVal == !that.kate;
			}
			that.kate = newVal;
		});

    that.$bus.$on('pending-tasks-count', function (newVal) {
      that.pendingTasksCount = newVal;
    });
	},
};
</script>

